import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';

const SelectWithIcons = (props) => {
  const customOptions = props.options.map(option => ({
    value: option.code,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img 
          src={option.icon || `/icon/${option.code}-sm.png`} 
          alt={option.name} 
          style={{ width: '15px', height: '15px', marginRight: '10px' }}
        />
        {option.name}
      </div>
    ),
    data: option
  }));

  const customStyles = {
    option: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      padding: '8px 12px'
    }),
    singleValue: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center'
    })
  };

  const handleChange = (selectedOption) => {
    
    if (props.onChange) {
      
      const mockEvent = {
        target: {
          value: selectedOption ? selectedOption.value : ""
        }
      };
      props.onChange(mockEvent);
    }
  };

  return (
    <Select
      options={customOptions}
      value={customOptions.find(opt => opt.value === props.value)}
      onChange={handleChange}
      styles={customStyles}
      className={props.className || "col-md-2"}
      placeholder={props.default}
      isClearable
    />
  );
};

export default SelectWithIcons;